<template>
    <div class="selectcoursediv">
        <div class="selectcourse clearfix">
            <div>{{this.form.sname.substring(0,1)}}</div>
            <div>
                <p @click="selectcourse">{{this.form.sname}} <span></span></p>
                <p>{{this.form.bookname}}</p>
            </div>
        </div>
        <div class="textbooklist">
            <div class="selebooklist">
                <el-tree class="treelist" :data="taskdata" accordion :props="defaultProps" @node-click="handleNodeClick"></el-tree>
            </div>
        </div>

        <!-- //选择弹窗 -->
        <el-dialog title="" :visible.sync="dialogFormVisible" class="bookcutpopup">
            <el-form :model="form">
                <el-form-item label="年级:" :label-width="formLabelWidth">
                     <el-select v-model="form.region1" placeholder="请选择年级">
                        <el-option v-for="item in this.gradedata" :key="item.gid" :label="item.grade_name" :value="item.gid" @click.native="changegid(item)"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="科目:" :label-width="formLabelWidth">
                     <el-select v-model="form.region2" placeholder="请选择科目">
                        <el-option v-for="item in this.subjectdata" :key="item.sid" :label="item.subject_name" :value="item.sid" @click.native="changesid(item)" ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="版本:" :label-width="formLabelWidth">
                    <el-select v-model="form.region3" placeholder="请选择版本">
                        <el-option v-for="item in this.booklist" :key="item.book_id" :label="item.book_name" :value="item.book_id" @click.native="changebookid(item)"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitform">确 定</el-button>
            </div>
        </el-dialog>



    </div>
</template>
<script>
import "../../assets/work.css"
import eventBus from "@/api/eventBus";
import URL from '@/api/index'
export default {
    data() {
        return{
            dialogFormVisible: false,
            form: {
                region1: 1,
                region2:1,
                region3:'',
                region4:'',
                sname:'',
            },
            formLabelWidth: '120px',
            Gid: 1,
            Sid: 1,
            Bookid:'',
            gradedata:[],
            subjectdata:[],
            booklist:[],
            taskdata: [],
            defaultProps: {
                children: 'son',
                label: 'chapter_name',
                type:'1'
            },
        }
    },
    mounted(){
        if (JSON.parse(localStorage.getItem("zjgradeCopy"))) {
            this.Gid = JSON.parse(localStorage.getItem("zjgradeCopy"))
            this.Sid = JSON.parse(localStorage.getItem("zjsidCopy"))
            this.form.region1 = JSON.parse(localStorage.getItem("zjgradeCopy"))
            // console.log(this.form)
        }

        this.getallgrade()
    },
    methods:{
         //选择年级 重新获取科目和课本
        changegid(val){
            // console.log(val,"gid",val.gid)
            this.Gid = val.gid
            this.form.gname = val.grade_name
            this.getgetsubject()
            // eventBus.$emit("gid",val) 
        },
        //选择科目  重新获取课本
        changesid(val){
            // console.log(val,"sid",val.sid)
            this.Sid = val.sid
            this.form.sname = val.subject_name
            this.getbooklist();   
        },
        //选择课本
        changebookid(val){
            // console.log(val,"bookid",val.book_id)
            this.Bookid = val.book_id
            this.form.bookname = val.book_name
            this.getbookchapter();
        },
        //左侧选择
        handleCommand(command) {
            // console.log(command) 
        },
        //选择课本
        selectcourse(){
            this.dialogFormVisible = true
        },
        //选择确定
        submitform(){
        //   console.log(this.form)
          this.dialogFormVisible = false
          eventBus.$emit("selectdata",this.form) 
        },
        //章节选择
        handleNodeClick(data) {
        //   console.log(data)
        },

        //获取年级
        getallgrade(){
            this.$post(URL.allgrade).then( res =>{
                this.gradedata = res.result.grade_list
                //初始化默认第一个
                this.form.gname = res.result.grade_list[0].grade_name
                this.getgetsubject();
            })
        },
        //获取科目
        getgetsubject(){
            var subjectval = {
                gid: this.Gid,
            }
            this.$post(URL.getsubject,subjectval).then( res=>{
                this.subjectdata = res.result.subject_list
                //默认是第一个科目
                if (JSON.parse(localStorage.getItem("zjgradeCopy"))) {
                    this.form.region2 = JSON.parse(localStorage.getItem("zjsidCopy"))
                    var nameinx = JSON.parse(localStorage.getItem("zjsidCopy"))
                    this.form.sname = res.result.subject_list[nameinx-1].subject_name
                }else{
                    this.form.region2 = res.result.subject_list[0].sid
                    this.form.sname = res.result.subject_list[0].subject_name
                }
            
                eventBus.$emit("subdata",res.result.subject_list) 
            })
            this.getbooklist()
        },
        //获取课本
        getbooklist(){
            var bookdata={
                gid: this.Gid,
                sid: this.Sid
            }
            this.$post(URL.getbooklist,bookdata).then( res=>{
                this.booklist = res.result.booklist
                this.form.region3 = res.result.booklist[0].book_id
                this.form.bookname = res.result.booklist[0].book_name
                this.Bookid = res.result.booklist[0].book_id
                this.getbookchapter();
            })
        },
        //课本内容
        getbookchapter(){
            var bookchapterdata = {
                cptid: this.Bookid
            }
            this.$post(URL.bookchapter,bookchapterdata).then( res =>{
                
                this.taskdata = res.result.menu
                eventBus.$emit("chapterid",this.taskdata[0].chapter_id) 
            })
        },
        //树形控件点击  任务
        handleNodeClick(data) {
            eventBus.$emit("treedata",data.chapter_id)  
        },
        


    }
}
</script>
<style scoped>
     body, html, div, blockquote, img, label, p, h1, h2, h3, h4, h5, h6, pre, ul, ol,
li, dl, dt, dd, form, a, fieldset, input, th, td, i, em{
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -ms-box-sizing: border-box;
    box-sizing: border-box;
}

.inner{
    margin-top: 15px;
}   
</style>